import styled from "@emotion/styled/macro";
import { Link } from "react-router-dom";
import { withProps } from "recompose";
import { useTranslation } from "react-i18next";
import { ContentLayout } from "../../../components/ui/ContentLayout";
import proof from "../../../assets/images/proof-of-life.png";
import proofMobile from "../../../assets/images/proof-of-life-mobile.png";

const Wrapper = styled.div`
  margin: 2em 0;
  background-image: url(${proofMobile});
  background-repeat: no-repeat;
  background-size: 100% 400px;
  padding-top: 450px;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    background-image: none;
    margin-bottom: 0;
    padding-top: 0;
    display: flex;
    align-items: center;
    clip-path: inset(-50px 0px 0px 0px);
    box-shadow: 0px 13px 40px 20px ${({ theme }) => theme.colors.opal};
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    min-height: 440px;
  }
`;
const TextWrapper = styled(ContentLayout)`
  display: flex;
  flex-direction: column;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 0 10% 0 2.5em;
    max-width: 500px;
  }
`;
const Title = styled.h2`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.xl};
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 0.2em;
`;
const SubTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.secondary};
  margin-bottom: 1em;
`;
const Text = styled.div`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};
  line-height: 1.5em;
`;
const Proof = withProps({ src: proof })(styled.img`
  display: none;
  width: 50%;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
  }
`);

const LearnMore = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 2.375em;
    width: 10em;
    margin: 1em 0 0 0;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 2em 0 0;
  }
  border: 1px solid ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  padding: 0.35em 0;
  text-align: center;
  font-weight: bold;
`;

const ProofInsurance = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Proof />
      <TextWrapper>
        <Title>{t("proofPart.title")}</Title>
        <SubTitle>{t("proofPart.subtitle")}</SubTitle>
        <Text>{t("proofPart.text")}</Text>

        <LearnMore as={Link} to={"/legal"}>
          {t("common.learnButton")}
        </LearnMore>
      </TextWrapper>
    </Wrapper>
  );
};

export default ProofInsurance;
